<template>
    <div v-if="active && quote_id" class="delete-impact">
        <div v-if="loading" class="delete-impact-loading">
            <v-progress-circular indeterminate size="16" width="2" color="#3988AA" class="mr-2" />
            Checking this quote…
        </div>
        <template v-else-if="check">
            <div v-if="!check.can_delete" class="delete-impact-box delete-impact-box--blocked">
                <v-icon small color="#B23B3B" class="mr-2">mdi-cash-lock</v-icon>
                <div>
                    <b>This quote can't be deleted.</b>
                    It has {{ check.payments_count }} payment{{ check.payments_count === 1 ? '' : 's' }} against it.
                    Unbook it instead, or refund the payments first.
                </div>
            </div>
            <div v-if="check.is_main_package || check.shared_services.length" class="delete-impact-box">
                <v-icon small color="#B26A00" class="mr-2">mdi-call-split</v-icon>
                <div>
                    <div v-if="check.is_main_package">
                        <b>This is the main package</b> for {{ check.variants.join(', ') }}.
                    </div>
                    <div v-if="check.shared_services.length" class="mt-1">
                        These suppliers stay booked for the other packages, and their groupsizes are
                        recalculated without this one:
                        <ul class="delete-impact-list">
                            <li v-for="shared in check.shared_services" :key="shared.service">
                                {{ shared.service }} <span class="delete-impact-packages">({{ shared.packages.join(', ') }})</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
// Shown in the delete quote confirmations: what deleting this quote affects (Copy Quote variants
// sharing its suppliers) and whether it's blocked (payments against it). Emits blocked(bool).
export default {
    props: {
        quote_id: { type: [Number, String], default: null },
        active: { type: Boolean, default: false },
    },
    data: () => ({
        loading: false,
        check: null,
    }),
    watch: {
        active: {
            immediate: true,
            handler(open) {
                if (open) this.load()
            },
        },
    },
    methods: {
        async load() {
            if (!this.quote_id) return
            this.loading = true
            this.check = null
            this.$emit('blocked', true)
            try {
                const { data } = await this.$axios.get(`admin/quotes/delete_check/${this.quote_id}`)
                this.check = data.response ? data.data : null
            } catch (error) {
                this.check = null
            }
            this.loading = false
            this.$emit('blocked', !!this.check && !this.check.can_delete)
        },
    },
}
</script>

<style lang="scss" scoped>
.delete-impact {
    margin-top: 12px;
    font-family: Manrope;
    font-size: 13px;
    color: #3D3D3D;
}

.delete-impact-loading {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #7C7C7C;
}

.delete-impact-box {
    display: flex;
    align-items: flex-start;
    padding: 10px 12px;
    margin-top: 8px;
    border-radius: 8px;
    border: 1px solid #F0C36D;
    background-color: #FFF8EA;
}

.delete-impact-box--blocked {
    border-color: #F1B5B5;
    background-color: #FDECEC;
}

.delete-impact-list {
    margin: 4px 0 0;
    padding-left: 18px;
}

.delete-impact-packages {
    color: #7C7C7C;
}
</style>
